import { render, staticRenderFns } from "./MedicineRegisterDialog.vue?vue&type=template&id=2be3dec7&scoped=true&"
import script from "./MedicineRegisterDialog.vue?vue&type=script&lang=ts&"
export * from "./MedicineRegisterDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineRegisterDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MedicineRegisterDialog.vue?vue&type=style&index=1&id=2be3dec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3dec7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VIcon,VImg,VRow,VSpacer})
